export const resolveHomePath = (userType) => {
  switch (userType) {
    case 'worker':
      return '/worker';
    case 'manager':
      return '/factory-manager';
    case 'sales':
      return '/sales';
    case 'sales-manager':
      return '/sales-manager';
    case 'accounting':
      return '/accounting';
    case 'admin':
      return '/company-manager';
    default:
      return '/';
  }
};
